import { Branding } from "./BrandingService";
import { LocalStorageService } from "./LocalStorageService";

const getConfig = () => {
    return window.AppSettings
}

/**
 * Sekme başlığındaki uygulama adı — 13 sayfa bunu çağırıyor.
 * Kaynak artık configuration.json değil MARKA (DB): beyaz etiket kurulumunda kiracının başlığı,
 * yoksa gömülü varsayılan ("HIS · eCloudPACS"). Tek nokta olduğu için sayfalara dokunmak gerekmedi.
 */
const getHisTitle = () => {
    return Branding.title('his', LocalStorageService.getLanguage('tr'))
}

const AppConfig = {
    getConfig,
    getHisTitle
}

export default AppConfig;
